// Componenty
import { ErrorBoundary } from 'components/hoc/ErrorBoundary';
import PrivateRoute from 'components/hoc/PrivateRoute';
// objekt s routama
import { routeMapa } from 'data/routeMapa';
import React from 'react';
import { HashRouter as Router, Route, Switch } from 'react-router-dom';

const AppRouter: React.FC = () => {
    return (
        <Router>
            <Switch>
                <ErrorBoundary>
                    {routeMapa().map((route, index) =>
                        route.private ? (
                            <PrivateRoute path={route.path} component={route.component} key={index} />
                        ) : (
                            <Route path={route.path} component={route.component} key={index} />
                        )
                    )}
                </ErrorBoundary>
            </Switch>
        </Router>
    );
};

export default AppRouter;
